export const allQuestions = [
    {
      category: "General Knowledge",
      questionText: "What is the capital of France?",
      answerOptions: [
        { answerText: "Berlin", isCorrect: false },
        { answerText: "Madrid", isCorrect: false },
        { answerText: "Paris", isCorrect: true },
        { answerText: "Rome", isCorrect: false },
      ],
    },
    {
      category: "General Knowledge",
      questionText: "Which ocean is the largest?",
      answerOptions: [
        { answerText: "Atlantic", isCorrect: false },
        { answerText: "Indian", isCorrect: false },
        { answerText: "Pacific", isCorrect: true },
        { answerText: "Arctic", isCorrect: false },
      ],
    },
    {
      category: "General Knowledge",
      questionText: "Who wrote 'Hamlet'?",
      answerOptions: [
        { answerText: "Charles Dickens", isCorrect: false },
        { answerText: "William Shakespeare", isCorrect: true },
        { answerText: "Jane Austen", isCorrect: false },
        { answerText: "Leo Tolstoy", isCorrect: false },
      ],
    },
    {
      category: "General Knowledge",
      questionText: "What is the largest planet in our solar system?",
      answerOptions: [
        { answerText: "Earth", isCorrect: false },
        { answerText: "Mars", isCorrect: false },
        { answerText: "Jupiter", isCorrect: true },
        { answerText: "Saturn", isCorrect: false },
      ],
    },
    {
      category: "General Knowledge",
      questionText: "Which country is known as the Land of the Rising Sun?",
      answerOptions: [
        { answerText: "China", isCorrect: false },
        { answerText: "South Korea", isCorrect: false },
        { answerText: "Japan", isCorrect: true },
        { answerText: "Thailand", isCorrect: false },
      ],
    },
    {
      category: "Science",
      questionText: "What is the chemical symbol for water?",
      answerOptions: [
        { answerText: "H2O", isCorrect: true },
        { answerText: "CO2", isCorrect: false },
        { answerText: "O2", isCorrect: false },
        { answerText: "H2", isCorrect: false },
      ],
    },
    {
      category: "Science",
      questionText: "What is the most common gas in the Earth's atmosphere?",
      answerOptions: [
        { answerText: "Oxygen", isCorrect: false },
        { answerText: "Carbon Dioxide", isCorrect: false },
        { answerText: "Nitrogen", isCorrect: true },
        { answerText: "Hydrogen", isCorrect: false },
      ],
    },
    {
      category: "Science",
      questionText: "Who developed the theory of general relativity?",
      answerOptions: [
        { answerText: "Isaac Newton", isCorrect: false },
        { answerText: "Albert Einstein", isCorrect: true },
        { answerText: "Nikola Tesla", isCorrect: false },
        { answerText: "Galileo Galilei", isCorrect: false },
      ],
    },
    {
      category: "Science",
      questionText: "What planet is known as the Red Planet?",
      answerOptions: [
        { answerText: "Mars", isCorrect: true },
        { answerText: "Earth", isCorrect: false },
        { answerText: "Venus", isCorrect: false },
        { answerText: "Jupiter", isCorrect: false },
      ],
    },
    {
      category: "Science",
      questionText: "What gas do plants absorb from the air for photosynthesis?",
      answerOptions: [
        { answerText: "Oxygen", isCorrect: false },
        { answerText: "Carbon Dioxide", isCorrect: true },
        { answerText: "Nitrogen", isCorrect: false },
        { answerText: "Hydrogen", isCorrect: false },
      ],
    },
    {
      category: "History",
      questionText: "Who was the first President of the United States?",
      answerOptions: [
        { answerText: "George Washington", isCorrect: true },
        { answerText: "Thomas Jefferson", isCorrect: false },
        { answerText: "Abraham Lincoln", isCorrect: false },
        { answerText: "John Adams", isCorrect: false },
      ],
    },
    {
      category: "History",
      questionText: "In which year did World War II end?",
      answerOptions: [
        { answerText: "1939", isCorrect: false },
        { answerText: "1945", isCorrect: true },
        { answerText: "1949", isCorrect: false },
        { answerText: "1950", isCorrect: false },
      ],
    },
    {
      category: "History",
      questionText: "Who was the first man to walk on the Moon?",
      answerOptions: [
        { answerText: "Neil Armstrong", isCorrect: true },
        { answerText: "Buzz Aldrin", isCorrect: false },
        { answerText: "Yuri Gagarin", isCorrect: false },
        { answerText: "Michael Collins", isCorrect: false },
      ],
    },
    {
      category: "History",
      questionText: "Who was the longest-reigning British monarch?",
      answerOptions: [
        { answerText: "Queen Victoria", isCorrect: false },
        { answerText: "Queen Elizabeth II", isCorrect: true },
        { answerText: "King George III", isCorrect: false },
        { answerText: "King Henry VIII", isCorrect: false },
      ],
    },
    {
      category: "History",
      questionText: "Who was the famous female aviator who disappeared over the Pacific Ocean?",
      answerOptions: [
        { answerText: "Amelia Earhart", isCorrect: true },
        { answerText: "Harriet Tubman", isCorrect: false },
        { answerText: "Clara Barton", isCorrect: false },
        { answerText: "Eleanor Roosevelt", isCorrect: false },
      ],
    },
    {
      category: "Geography",
      questionText: "What is the longest river in the world?",
      answerOptions: [
        { answerText: "Amazon River", isCorrect: false },
        { answerText: "Nile River", isCorrect: true },
        { answerText: "Yangtze River", isCorrect: false },
        { answerText: "Mississippi River", isCorrect: false },
      ],
    },
    {
      category: "Geography",
      questionText: "Which country has the most islands?",
      answerOptions: [
        { answerText: "Sweden", isCorrect: true },
        { answerText: "Canada", isCorrect: false },
        { answerText: "Finland", isCorrect: false },
        { answerText: "Indonesia", isCorrect: false },
      ],
    },
    {
      category: "Geography",
      questionText: "Which desert is the largest in the world?",
      answerOptions: [
        { answerText: "Sahara", isCorrect: false },
        { answerText: "Kalahari", isCorrect: false },
        { answerText: "Antarctic Desert", isCorrect: true },
        { answerText: "Gobi", isCorrect: false },
      ],
    },
    {
      category: "Geography",
      questionText: "What is the smallest country in the world by land area?",
      answerOptions: [
        { answerText: "Monaco", isCorrect: false },
        { answerText: "Vatican City", isCorrect: true },
        { answerText: "Nauru", isCorrect: false },
        { answerText: "San Marino", isCorrect: false },
      ],
    },
    {
      category: "Geography",
      questionText: "What is the largest island in the world?",
      answerOptions: [
        { answerText: "Greenland", isCorrect: true },
        { answerText: "Australia", isCorrect: false },
        { answerText: "New Guinea", isCorrect: false },
        { answerText: "Borneo", isCorrect: false },
      ],
    },
  ];
